import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Clock, Lock } from "lucide-react";
import { Button } from "@/components/ui-kit";

// Shows trial countdown or a soft-lock upgrade prompt. Pass onUpgrade to wire
// the CTA (e.g. open the plan modal). Renders nothing for subscribed/exempt users.
export default function AccessBanner({ onUpgrade, variant = "full" }) {
  const [a, setA] = useState(null);
  useEffect(() => { api.get("/account/access").then(({ data }) => setA(data)).catch(() => {}); }, []);
  if (!a || a.subscribed || a.exempt) return null;

  if (a.locked) {
    return (
      <div className="mb-5 flex flex-wrap items-center justify-between gap-3 rounded-[var(--ns-radius)] border-2 p-4"
        style={{ borderColor: "#D96B43", background: "#FBEDE6" }} data-testid="trial-locked-banner">
        <div className="flex items-start gap-3">
          <Lock size={20} className="text-[#B23A28] mt-0.5 shrink-0" />
          <div className="text-sm text-[var(--ns-text)]">
            <b>Your free trial has ended.</b> Your progress is safely saved — upgrade to keep practicing and add children.
          </div>
        </div>
        {onUpgrade && <Button data-testid="banner-upgrade-btn" onClick={onUpgrade}>Upgrade now</Button>}
      </div>
    );
  }

  if (a.trial_active) {
    const d = a.trial_days_left;
    return (
      <div className="mb-5 flex flex-wrap items-center justify-between gap-3 rounded-[var(--ns-radius)] border p-4"
        style={{ borderColor: "var(--ns-border)", background: "var(--ns-primary-light)" }} data-testid="trial-active-banner">
        <div className="flex items-start gap-3">
          <Clock size={20} className="text-[var(--ns-primary)] mt-0.5 shrink-0" />
          <div className="text-sm text-[var(--ns-text)]">
            <b>{d} day{d === 1 ? "" : "s"} left</b> in your free trial. Enjoying NumberSense? Lock in a plan anytime.
          </div>
        </div>
        {onUpgrade && variant === "full" && <Button variant="subtle" data-testid="banner-upgrade-btn" onClick={onUpgrade}>See plans</Button>}
      </div>
    );
  }
  return null;
}
